import { get, isEqual, union } from 'lodash';
import { SETTINGS_SCHEMA } from './settingsSchema';
import { validateSetting } from './SettingField';

// Collect the leaf paths of a config object (arrays are treated as leaves).
const collectLeafPaths = (obj, prefix = '') => {
  let paths = [];
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return prefix ? [prefix] : [];
  }
  for (const key of Object.keys(obj)) {
    const full = prefix ? `${prefix}.${key}` : key;
    const val = obj[key];
    if (val && typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length > 0) {
      paths = paths.concat(collectLeafPaths(val, full));
    } else {
      paths.push(full);
    }
  }
  return paths;
};

// Diff two config objects at leaf-path granularity.
// Returns [{ key, oldValue, newValue }] for every changed/added/removed path.
export const diffConfigs = (oldCfg = {}, newCfg = {}) => {
  const paths = union(collectLeafPaths(oldCfg || {}), collectLeafPaths(newCfg || {})).sort();
  const changes = [];
  for (const p of paths) {
    const oldValue = get(oldCfg, p);
    const newValue = get(newCfg, p);
    if (!isEqual(oldValue, newValue)) {
      changes.push({ key: p, oldValue, newValue });
    }
  }
  return changes;
};

// Validate every registered setting in a config object.
// Returns [{ key, label, error }] — empty array means the config is valid.
export const validateConfig = (config) => {
  const errors = [];
  SETTINGS_SCHEMA.forEach(schema => {
    const value = get(config, schema.key);
    if (value === undefined) return;
    const error = validateSetting(schema, value);
    if (error) errors.push({ key: schema.key, label: schema.label, error });
  });
  return errors;
};

export const formatValue = (val) => {
  if (val === undefined) return '(not set)';
  const str = typeof val === 'string' ? `"${val}"` : JSON.stringify(val);
  return str.length > 120 ? `${str.slice(0, 117)}...` : str;
};
